<template>
  <base-container class="layout-row" ref="container" :isLoading="loading">
    <artisan-group
      title="检验资源"
      border
      style="height: 100%; width: 240px; background-color: #fff"
    >
      <el-menu :default-active="resId" @select="selectRes">
        <el-menu-item
          :disabled="!res.isSchedule"
          :index="res.id"
          v-for="res in resources"
          :key="res.id"
        >
          <i class="el-icon-menu"></i>
          <span slot="title">{{ res.name }}</span>
        </el-menu-item>
      </el-menu>
    </artisan-group>
    <div
      style="
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        margin: 0 5px;
        height: 100%;
      "
    >
      <artisan-calendar
        v-model="scheduleDate"
        ref="calendar"
        @monthChange="monthChange"
      >
        <template slot="dateCell" slot-scope="{ date }">
          <el-row
            style="position: relative; margin: 2px"
            :class="getDateClass(date)"
            type="flex"
            align="middle"
          >
            <div
              :class="date == scheduleDate ? 'date-current' : ''"
              class="schedule-date"
            >
              {{ date.slice(-2) }}
            </div>
            <div style="flex: 1" class="align-center color-gray">
              <div
                v-if="dayScheduleMap[date] && dayScheduleMap[date].hasSchedule"
                style="font-size: 19px"
                class="color-info"
              >
                <span class="color-success">
                  {{ dayScheduleMap[date].resCount }}
                </span>
                <span style="margin: 0 3px">/</span>
                <span>
                  {{ dayScheduleMap[date].totalCount }}
                </span>
              </div>
              <div
                v-else
                class="color-gray align-center"
                style="margin: 10px 5px"
              >
                --
              </div>
            </div>
            <el-tag
              size="mini"
              v-if="
                dayScheduleMap[date] &&
                dayScheduleMap[date].dateType == 'holiday'
              "
              style="position: absolute; right: 0; top: 0"
              type="success"
              effect="dark"
            >
              休
            </el-tag>
            <el-tag
              size="mini"
              v-else-if="
                dayScheduleMap[date] &&
                dayScheduleMap[date].dateType == 'adjust'
              "
              style="position: absolute; right: 0; top: 0"
              type="danger"
              effect="dark"
            >
              班
            </el-tag>
          </el-row>
        </template>
      </artisan-calendar>
      <div style="flex: 1; overflow: hidden">
        <ArtisanGrid
          ref="schedule"
          metaKey="JyScheduleInfo"
          :metaInited="metaInited"
          :query="{ resourceId: resId, scheduleDate: scheduleDate }"
        >
          <template #pageRight>
            <div style="margin-right: 20px">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit-outline"
                @click="tempSchedule"
              >
                临时排班
              </el-button>
              <!-- <el-button
              type="danger"
              size="mini"
              icon="el-icon-edit"
              @click="stopChange"
            >
              停诊患者改约
            </el-button> -->
              <el-button
                type="success"
                size="mini"
                icon="el-icon-date"
                @click="reBuildSchedule"
              >
                刷新排班
              </el-button>
            </div>
          </template>
          <template #status="{ row }">
            <el-tag
              :type="statusMap[row.status].type"
              effect="dark"
              size="medium"
            >
              {{ statusMap[row.status].label }}
            </el-tag>
          </template>
          <template #totalCount="{ row }">
            <i
              class="el-icon-minus color-danger clickable border-gray padding3"
              @click="changeNum(row, false)"
            ></i>
            <span class="color-primary margin-h5">{{ row.totalCount }}</span>
            <i
              class="el-icon-plus color-success clickable border-gray padding3"
              @click="changeNum(row, true)"
            ></i>
          </template>
          <template #operation>
            <el-table-column
              :width="80"
              label="操作"
              fixed="right"
              align="center"
              class-name="back-white"
            >
              <template slot-scope="{ row }">
                <el-button
                  class="margin-h5 color-danger"
                  icon="el-icon-stopwatch"
                  size="mini"
                  type="text"
                  v-if="stopable(row)"
                  @click="stopSchedule(row)"
                >
                  停诊
                </el-button>
                <el-button
                  class="margin-h5"
                  icon="el-icon-stopwatch"
                  size="mini"
                  type="text"
                  v-if="regainable(row)"
                  @click="regainSchedule(row)"
                >
                  恢复
                </el-button>
              </template>
            </el-table-column>
          </template>
        </ArtisanGrid>
      </div>
    </div>
    <artisan-dialog
      :title="'临时排班--' + (res.name || '')"
      ref="tempDialog"
      height="90%"
      width="90%"
      :visible.sync="addDialog.show"
      :isLoading="addDialog.loading"
    >
      <TempScheduleSetting
        ref="tempSchedule"
        v-if="addDialog.show"
        :resId="resId"
        @rule-saved="refreshSchedule"
      >
      </TempScheduleSetting>
      <template #footer>
        <el-button
          type="success"
          size="mini"
          icon="el-icon-edit-outline"
          @click="saveTempSchedule"
        >
          保存排班规则
        </el-button>
      </template>
    </artisan-dialog>
    <artisan-dialog
      :title="'诊患者改约(' + (res.name || '') + '--' + scheduleDate + ')'"
      height="75%"
      width="75%"
      :visible.sync="stopDialog.show"
      :isLoading="stopDialog.loading"
    >
      <StopScheduleHandle
        v-if="stopDialog.show"
        :schedule-date="scheduleDate"
        :schedules="checkSchedules"
      >
      </StopScheduleHandle>
    </artisan-dialog>
  </base-container>
</template>

<script>
import { getAuthResource } from "@/api/jy/reserve";
import {
  loadSchedule,
  stop,
  regain,
  plus,
  reSchedule,
  saveTempSchedule,
} from "@/api/jy/schedule";
import Constant from "@/config/constant.js";
import { buildTree, getClinicTypeLabel, getCalendarInfo } from "@/util/util";
import moment from "moment";
import TempScheduleSetting from "./schedule/TempScheduleSetting.vue";
import StopScheduleHandle from "./schedule/StopScheduleHandle.vue";
export default {
  inject: ["index"],
  components: { TempScheduleSetting, StopScheduleHandle },
  data() {
    return {
      defaultProps: {
        emitPath: false,
        checkStrictly: true,
        expandTrigger: "hover",
        children: "children",
        label: "name",
        value: "id",
      },
      loading: false,
      resources: [],
      resId: "",
      scheduleDate: moment().format("YYYY-MM-DD"),
      schedules: [],
      addDialog: {
        show: false,
        loading: false,
        addDates: [],
      },
      stopDialog: {
        show: false,
        loading: false,
      },
      statusMap: {
        normal: {
          label: "未约满",
          type: "success",
        },
        full: {
          label: "已约满",
          type: "warning",
        },
        stop: {
          label: "已停诊",
          type: "danger",
        },
      },
    };
  },
  computed: {
    dayScheduleMap() {
      let scheduleMap = {};
      this.schedules.forEach((c) => {
        scheduleMap[c.scheduleDate] = c;
      });
      return scheduleMap;
    },
    resTree() {
      return buildTree(this.resources);
    },
    res() {
      let res = this.resources.find((c) => c.id == this.resId);
      return res || {};
    },
  },
  watch: {
    scheduleDate() {
      this.$refs.schedule.reload({ scheduleDate: this.scheduleDate });
    },
  },
  created() {
    getAuthResource().then((res) => {
      this.resources = res.data.data;
      if (this.resources.length) {
        this.resId = this.resources[0].id;
        let { start, end } = getCalendarInfo(this.scheduleDate);
        this.loadSchedule(start, end);
      }
    });
  },
  methods: {
    getClinicTypeLabel,
    metaInited(option) {
      option.rowType = "index";
      option.btns = [];
      option.columns.forEach((c) => {
        c.isSearch = false;
        if (c.code == "weekNo") {
          c.dicData = Constant.weeks.map((c) => {
            return {
              value: c.weekNo,
              label: c.name,
            };
          });
        } else if (c.code == "clinicType") {
          c.dicData = [
            {
              value: "",
              label: "不限",
            },
            {
              value: "outpatient",
              label: "门诊",
            },
            {
              value: "inpatient",
              label: "住院",
            },
          ];
        } else if (c.code == "scheduleDate") {
          c.searchType = "";
        }
      });
      return option;
    },
    selectRes(index) {
      this.resId = index;
      let { start, end } = getCalendarInfo(this.scheduleDate);
      this.loadSchedule(start, end);
      this.$refs.schedule.reload({ resourceId: this.resId });
    },
    loadSchedule(start, end) {
      this.loading = true;
      loadSchedule(this.resId, start, end)
        .then((res) => {
          let data = res.data.data;
          this.schedules = data;
          this.loading = false;
          this.addDialog.show = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    refreshSchedule() {
      let { start, end } = getCalendarInfo(this.scheduleDate);
      console.log(start,end)
      this.loadSchedule(start, end);
    },
    monthChange({ start, end }) {
      this.loadSchedule(start, end);
    },
    getDateClass(date) {
      let now = moment().format("YYYY-MM-DD");
      if (this.dayScheduleMap[date] && this.dayScheduleMap[date].hasSchedule) {
        return date >= now ? "back-success-light" : "back-info-light";
      }
      return "";
    },
    saveTempSchedule() {
      let scheduleData = this.$refs.tempSchedule.getData();
      if (scheduleData.scheduleDates.length && scheduleData.schedules.length) {
        this.$refs.tempDialog
          .confirm({ msg: "确认保存临时排班规则！" })
          .then(() => {
            this.addDialog.loading = true;
            saveTempSchedule(scheduleData)
              .then((res) => {
                this.addDialog.loading = false;
                this.$message({
                  type: "success",
                  message: "保存成功！",
                });
                this.addDialog.isShow = false;
                this.refreshSchedule();
              })
              .catch(() => {
                this.addDialog.loading = false;
              });
          });
      } else {
        this.$message({
          type: "warning",
          message: "请输入临时排班日期且设置排班！",
        });
      }
    },
    reBuildSchedule() {
      this.$refs.container
        .confirm({ msg: "是否刷新当前选中检验资源的排班？" })
        .then(() => {
          this.loading = true;
          return reSchedule(this.resId);
        })
        .then(() => {
          let { start, end } = getCalendarInfo(this.scheduleDate);
          this.loadSchedule(start, end);
          this.$message({
            type: "success",
            message: "刷新成功！",
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    stopable(detail) {
      let able = false;
      let current = moment().format("YYYY-MM-DD");
      let point = moment().format("HH:mm");
      if (detail.scheduleDate == current) {
        able = detail.endPoint > point;
      } else if (detail.scheduleDate > current) {
        able = true;
      }
      if (able) {
        able = detail.status != "stop";
      }
      return able;
    },
    regainable(detail) {
      let able = false;
      let current = moment().format("YYYY-MM-DD");
      let point = moment().format("HH:mm");
      if (detail.scheduleDate == current) {
        able = detail.endPoint > point;
      } else if (detail.scheduleDate > current) {
        able = true;
      }
      if (able) {
        able = detail.status == "stop";
      }
      return able;
    },
    stopSchedule(row) {
      this.$refs.container.confirm({ msg: "请确认停诊排班？" }).then(() => {
        this.loading = true;
        stop(this.scheduleDate, row.id)
          .then(() => {
            this.$message({
              type: "success",
              message: "停诊成功！",
            });
            this.$refs.schedule.reload();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    regainSchedule(row) {
      this.$refs.container.confirm({ msg: "请确认恢复排班？" }).then(() => {
        this.loading = true;
        regain(this.scheduleDate, row.id)
          .then(() => {
            this.$message({
              type: "success",
              message: "恢复成功！",
            });
            this.$refs.schedule.reload();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    tempSchedule() {
      if (this.resId) {
        this.addDialog.show = true;
      } else {
        this.$message({
          type: "warning",
          message: "请先选择左侧的检验资源,再进行临时排班操作！",
        });
      }
    },
    changeNum(row, isPlus) {
      this.$refs.container
        .prompt({ msg: `请输入要${isPlus ? "增加" : "减少"}的号源数` })
        .then((val) => {
          if (!isNaN(val)) {
            let num = parseInt(val);
            if (num < 0) {
              this.$message({
                type: "warning",
                message: "请输入整数",
              });
              return;
            }
            this.loading = true;
            plus(row.id, isPlus ? num : -num)
              .then(() => {
                this.$refs.schedule.reload();
                this.loading = false;
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            this.$message({
              type: "warning",
              message: "请输入正确的号源数",
            });
          }
        });
    },
    stopChange() {
      this.index.addTab({
        name: "停诊患者改约(" + this.res.name + "--" + this.scheduleDate + ")",
        icon: "el-icon-edit",
        url:
          `jc/schedule/StopScheduleHandle?scheduleDate=` +
          this.scheduleDate +
          "&resourceId=" +
          this.resId,
      });
    },
  },
};
</script>

<style scoped>
.schedule-date {
  height: 40px;
  line-height: 40px;
  width: 40px;
  font-size: 1.5rem;
  margin: 5px;
  text-align: center;
}
.date-current {
  border-radius: 50%;
  background-color: #409eff;
  color: white;
  text-align: center;
}
</style>
